import React from 'react'
// import { Link, Image } from '@ta-interaktiv/contentbricks'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
const isMobile = browserCheck.isMobile

export const qanda = [
  {
    id: 'luxusuhr-1',
    type: 'slider',
    unit: 'CHF',
    question: 'À combien évaluez-vous le prix de cette montre?',
    correctAnswer: 120000,
    clockType: 'Jaeger-LeCoultre Master Grande Tradition Minute Repeater',
    erklaerung: (
      <>
        <h5>La bonne réponse est:</h5>
        <p>
          120’000 francs. C'est environ 40’000 fois le
          salaire minimum mensuel au Venezuela.
        </p>
      </>
    )
  },
  {
    id: 'luxusuhr-2',
    type: 'slider',
    unit: 'CHF',
    question: 'À combien évaluez-vous le prix de cette montre?',
    correctAnswer: 70000,
    clockType: 'Rolex Daytona Cosmograph (Platinum)',
    erklaerung: (
      <>
        <h5>La bonne réponse est:</h5>
        <p>
          70’000 francs. Cela représente environ 40 fois le produit intérieur brut par habitant du Venezuela.
        </p>
      </>
    )
  },
  {
    id: 'luxusuhr-3',
    type: 'slider',
    unit: 'CHF',
    question: 'À combien évaluez-vous le prix de cette montre?',
    correctAnswer: 300000,
    clockType: 'Greubel Forsey GMT Global Double Tourbillon (Or blanc)',
    erklaerung: (
      <>
        <h5>La bonne réponse est:</h5>
        <p>
          300’000 francs. C'est environ 100’000 fois le salaire minimum mensuel au Venezuela.
        </p>
      </>
    )
  },
  {
    id: 'luxusuhr-4',
    type: 'slider',
    unit: 'CHF',
    question: 'À combien évaluez-vous le prix de cette montre?',
    correctAnswer: 100000,
    clockType:
      'Hublot Big Bang Chronography Tourbillon, modèle anniversaire pour les 20 ans de Ferrari en Chine',
    erklaerung: (
      <>
        <h5>La bonne réponse est:</h5>
        <p>
          100’000 francs. Cela représente environ 57 fois le produit intérieur brut par habitant du Venezuela.
        </p>
      </>
    )
  },
  {
    id: 'luxusuhr-5',
    type: 'slider',
    unit: 'CHF',
    question: 'À combien évaluez-vous le prix de cette montre?',
    correctAnswer: 90000,
    clockType: 'Patek Philippe Nautilus',
    erklaerung: (
      <>
        <h5>La bonne réponse est:</h5>
        <p>
          90’000 francs. C'est environ 30’000 fois le salaire minimum mensuel au Venezuela.
        </p>
      </>
    )
  }
]
